import React, {useCallback, useContext, useEffect, useRef, useState} from 'react';

import {useSelector} from 'react-redux';
import {FontsDropdown} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/Dropdown/FontsDropdown/FontsDropdown';
import {UpDownChevron} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/Dropdown/UpDownChevron/UpDownChevron';
import {RecommendedFonts} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/Dropdown/RecommendedFonts/RecommendedFonts';
import {EventCreateContext} from '~/CreateFabricInvitation/routes/EventCreateDesign/EventCreateContext';
import {selectEditorDisabled} from '~/CreateFabricInvitation/reducers/fabricDesign/selectors';
import {useOutsideAlerter} from '~/CreateFabricInvitation/routes/EventCreateDesign/hooks/useOutsideAlerter';
import './Dropdown.sass';
import {mapFabricFontToLocal} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/Dropdown/utils';

export const Dropdown = () => {
  const [showMenu, setShowMenu] = useState(false);
  const {canvas, activeObjects} = useContext(EventCreateContext);
  const editorDisabled = useSelector(selectEditorDisabled);
  const [selectedValue, setSelectedValue] = useState();
  const wrapperRef = useRef(null);

  const updateValue = (obj) => {
    setSelectedValue(
      mapFabricFontToLocal({
        fontFamily: obj.fontFamily,
        fontStyle: obj.fontStyle,
        fontWeight: obj.fontWeight,
      })
    );
  };

  useEffect(() => {
    const updateActiveObjectValue = () => updateValue(canvas?.getActiveObjects()?.[0] || {});

    updateActiveObjectValue();
    canvas?.on('object:reset', updateActiveObjectValue);

    return () => {
      canvas?.off('object:reset', updateActiveObjectValue);
    };
  }, [canvas, activeObjects]);

  const toggleDropdown = useCallback((e) => {
    e.stopPropagation();
    setShowMenu((prevState) => !prevState);
  }, []);

  const closeMenu = useCallback(() => {
    setShowMenu(false);
  }, []);

  useOutsideAlerter(wrapperRef, closeMenu);

  const onChangeHandler = useCallback(
    (value) => {
      setSelectedValue(value);
      setShowMenu(false);
      activeObjects.forEach((obj) =>
        obj.set({
          fontFamily: value.family,
          fontStyle: value.style,
          fontWeight: value.weight,
        })
      );
      canvas.requestRenderAll();
      canvas.fire('object:modified');
    },
    [activeObjects, canvas]
  );

  return (
    <div className="dropdown_container" ref={wrapperRef}>
      <div
        onClick={editorDisabled ? undefined : toggleDropdown}
        className={`selected_font_wrapper ${editorDisabled && 'selected_font_wrapper--disabled'}`}
        data-qa-id="step1-textstyle-dropdown"
      >
        <div
          style={{
            fontFamily: selectedValue?.family,
            fontWeight: selectedValue?.weight,
            fontStyle: selectedValue?.style,
          }}
        >
          {selectedValue?.name}
        </div>
        <UpDownChevron up={showMenu} ratio={0.7} />
      </div>
      {showMenu && (
        <div className="dropdown_menu">
          <div className="dropdown_menu__upper">
            <RecommendedFonts onChange={onChangeHandler} selectedFont={selectedValue} />
          </div>
          <div className="dropdown_menu__lower">
            <FontsDropdown
              placeHolder="ALL FONTS"
              onChange={onChangeHandler}
              selectedFont={selectedValue}
            />
          </div>
        </div>
      )}
    </div>
  );
};
